class PrintPdf{
  constructor(props){
  }

  static print(printable){
    var sOption="toolbar=yes,location=no,directories=yes,menubar=yes,scrollbars=yes,width=900,height=768";
    var sWinHTML = printable;
    var winprint = window.open("","",sOption);
        winprint.document.open();
        winprint.document.write('<html><head><style type="text/css">');
        winprint.document.write('body,td,th{font-family:Arial, Helvetica, sans-serif;font-size:14px;color:#000000}');
        winprint.document.write('.title-relatorio {font-size: 20px; border-bottom: 1px solid #dddddd; padding-bottom: 10px; margin-bottom: 20px;}');
        winprint.document.write('.item-relatorio {padding-bottom: 10px;margin-bottom: 10px;border-bottom: 1px solid #dddddd;}');
        winprint.document.write('.item-relatorio__title{font-size: 18px;font-weight: 600;}');
        winprint.document.write('</style></head><body>');
        winprint.document.write(sWinHTML);
        winprint.document.write('</body></html>');
        winprint.print();
        winprint.close();
  }
}

export default PrintPdf;



// WEBPACK FOOTER //
// ./src/utils/print/PrintPdf.js